import BookAppointment from 'pages/bookAppointment';
import ContactUs from 'pages/contactUs';
import RouteEnum from 'constants/RouteEnum';
// import { CreditScore } from 'pages/report';
// import { VehicleSearch } from 'pages/tradeIn/components/VehicleSearch';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PageNotFound from './components/PageNotFound';
import TradeIn from 'pages/tradeIn';
import WidgetShowcase from 'pages/demo';
import GoogleReview from 'pages/googleReview';
import CreditScore from 'pages/creditScore';
import LeadGenStepperForm from 'pages/leadGen';
import withTokenValidation from 'sharedComponents/hoc/withTokenValidation';
import React from 'react';
import ShowCase from 'pages/showCase/ShowCase';
import DigitalRetailing from 'pages/digitalRetailing';
import CheckAvailability from 'pages/checkAvailability';
import MultiCTA from 'pages/multiCTA';

export const WidgetRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteEnum.Root} element={<LeadGenStepperForm />}></Route>
      {/* <Route path={RouteEnum.creditScore} element={<CreditScore />}></Route> */}
      {/* <Route
        path={`${RouteEnum.creditScoreNew}/:leadSourceId/:version/:token`}
        // element={React.createElement(withTokenValidation(CreditScoreNew))}
        element={<CreditScore />}
      ></Route> */}
      {/* <Route path={RouteEnum.vehicleSearch} element={<VehicleSearch />}></Route> */}
      {/* <Route path={`${RouteEnum.tradeIn}/:leadSourceId/:version`} element={<TradeIn />}></Route> */}
      {/* <Route path={`${RouteEnum.tradeIn}/:token`} element={<TradeIn />}></Route> */}

      <Route path={`${RouteEnum.tradeIn}/:token`} element={React.createElement(withTokenValidation(TradeIn))}></Route>

      {/* <Route path={`${RouteEnum.creditScoreNew}/:token`} element={<CreditScore />}></Route> */}
      <Route
        path={`${RouteEnum.creditScoreNew}/:token`}
        element={React.createElement(withTokenValidation(CreditScore))}
      ></Route>
      {/* <Route path={`${RouteEnum.DigitalRetailing}/:token`} element={<DigitalRetailing />}></Route> */}
      <Route
        path={`${RouteEnum.DigitalRetailing}/:token`}
        element={React.createElement(withTokenValidation(DigitalRetailing))}
      ></Route>

      <Route
        path={`${RouteEnum.leadGen}/:token`}
        element={React.createElement(withTokenValidation(LeadGenStepperForm))}
      ></Route>

      <Route path={`${RouteEnum.MultiCTA}/:token`} element={<MultiCTA />}></Route>

      {/* <Route path={`${RouteEnum.leadGen}/:version`} element={<LeadGenStepperForm />}></Route> */}
      <Route path={`showcase/:widgetName`} element={<WidgetShowcase />}></Route>
      <Route path={RouteEnum.GoogleReview} element={<GoogleReview />}></Route>
      <Route path={RouteEnum.Showcase} element={<Navigate to='/show-case/trade-in' replace />}></Route>
      <Route path={`${RouteEnum.Showcase}/:widgetName`} element={<ShowCase />} />
      <Route path='*' element={<PageNotFound />} />
      {/* <Route path={`${RouteEnum.ContactUs}/:token`} element={<ContactUs />} /> */}
      {/* <Route path={`${RouteEnum.BookAppointment}/:token`} element={<BookAppointment />} /> */}
      {/* <Route path={`${RouteEnum.CheckAvailability}/:token`} element={<CheckAvailability />}></Route> */}

      <Route
        path={`${RouteEnum.CheckAvailability}/:token`}
        element={React.createElement(withTokenValidation(CheckAvailability))}
      ></Route>

      <Route
        path={`${RouteEnum.ContactUs}/:token`}
        element={React.createElement(withTokenValidation(ContactUs, 'contactUs'))}
      ></Route>

      <Route
        path={`${RouteEnum.BookAppointment}/:token`}
        element={React.createElement(withTokenValidation(BookAppointment, 'bookAppointment'))}
      ></Route>
    </Routes>
  );
};
